<template>
  <tr
    @click="onSwap"
    class="animate__animated animate__fadeIn"
    v-show="position.totalPrice > 0 || showRugs"
  >
    <td class="pt-2 ps-2">
      <TokenImage
        :hide-link="true"
        :mint="position.account.data.parsed.info.mint"
        :show-symbol="true"
      ></TokenImage>
    </td>
    <td v-if="!compact" class="account d-none d-xl-table-cell">
      <AccountAddress
        :full="true"
        :address="position.account.data.parsed.info.mint"
      ></AccountAddress>
    </td>

    <td class="text-center">
      <code>{{
        convertToHumanNumber(
          position.account.data.parsed.info.tokenAmount.uiAmountString
        )
      }}</code>
    </td>
    <td class="text-end d-none d-md-table-cell">
      <code>{{ fmt.format(price || 0) }}</code>
    </td>
    <td class="text-end">
      <code>{{ totalPrice() }}</code>
    </td>
    <td v-if="!compact" class="text-center text-sm-end">
      <button @click="onSwap" class="btn btn-solid-primary ms-2 d-none d-sm-inline-block">SWAP</button>
      <button @click="onSwap" class="btn btn-solid-primary ms-2 d-sm-none"><i class="fa fa-arrow-right-arrow-left"></i></button>
    </td>
  </tr>
</template>

<script>
import TokenImage from "@/components/common/TokenImage.vue";
import AccountAddress from "@/components/common/AccountAddress.vue";

export default {
  name: "BotRow",
  components: { AccountAddress, TokenImage },
  props: {
    position: {
      type: Object,
      required: true,
    },
    price: {
      type: Number,
    },
    showRugs: {
      type: Boolean,
    },
    compact: {
      type: Boolean,
    },
  },
  methods: {
    onSwap: function (e) {
      e.preventDefault();
      e.cancelBubble = true;
      e.stopPropagation();

      const mint = this.position.account.data.parsed.info.mint;
      this.$emit("swap", mint);
    },
    totalPrice: function () {
      if (this.position.totalPrice < 0.01) return "<$0.01";



      return this.fmtTotal.format(this.position.totalPrice);
    },
    convertToHumanNumber: function (num) {
      if (num < 1000) return (num / 1).toFixed(4).toString();
      if (num < 1000000) return (num / 1000).toFixed(2) + "k";
      if (num < 1000000000) return (num / 1000000).toFixed(2) + "m";
      if (num < 1000000000000) return (num / 1000000000).toFixed(2) + "b";
      return (num / 1000000000000).toFixed(2) + "t";
    },
  },
  data() {
    return {
      fmt: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 6,
      }),
      fmtTotal: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }),
    };
  },
};
</script>

<style scoped>
code {
  font-size: 1rem !important;
  letter-spacing: 1px;
}

td {
	padding:0;
}

td {
	vertical-align: middle;
}

tr:first-child {
  max-width: 20%;
  overflow: hidden;
}
tr td:last-child {
	width: 1%;
	white-space: nowrap;
}
</style>
